<script setup>
import { computed } from 'vue'

const props = defineProps({
	value: {
		type: Number,
		default: 0,
	},
	max: {
		type: Number,
		default: 100,
	},
	animated: {
		type: Boolean,
		default: false,
	},
	variant: {
		type: String,
		default: 'main',
	},
	heightClass: {
		type: String,
		default: 'h-2',
	},
})

const percent = computed(() => {
	if (!props.max) return 0
	return Math.min(100, Math.round((props.value / props.max) * 100))
})

const barClass = computed(() => {
	if (props.variant === 'main') return 'bg-main'
	return 'bg-surface-5'
})
</script>

<template>
	<div
		class="w-full overflow-hidden rounded-full bg-surface-3"
		:class="heightClass"
		role="progressbar"
		:aria-valuenow="value"
		:aria-valuemin="0"
		:aria-valuemax="max"
	>
		<div
			class="h-full transition-all duration-300"
			:class="[barClass, { 'animate-pulse': animated }]"
			:style="{ width: `${percent}%` }"
		/>
	</div>
</template>
